import CardsContainer from '../../../../components/common/cards/CardsContainer';
import ContactItem from '../../../../components/common/contact/ContactItem';
import {
	PressReleaseSectionWrapper,
	StyledPressReleaseSectionHeader,
} from './PressReleasePage.styles';
import HASLogo from '../../../../assets/airport-logos/has-logo-horizontal.svg';

export default function PressReleaseContactSection() {
	return (
		<PressReleaseSectionWrapper>
			<StyledPressReleaseSectionHeader>
				Contact us
			</StyledPressReleaseSectionHeader>
			<CardsContainer>
				<ContactItem
					title="Houston Airports Communications Office"
					links={{ email: 'HAS.PIO@HoustonTX.gov' }}
					imageSource={<HASLogo />}
					phoneNumber="281-233-1234"
				/>
			</CardsContainer>
		</PressReleaseSectionWrapper>
	);
}
